import { Pipe, PipeTransform } from '@angular/core';
import { AVAILABLE_LANGUAGES } from './languages';

const LANGUAGE_DISPLAY_NAME_MAP = new Map(
  AVAILABLE_LANGUAGES.map((lang) => [lang.code, lang.displayNameEn]),
);

@Pipe({
  standalone: true,
  name: 'languageDisplayName',
})
export class LanguageDisplayNamePipe implements PipeTransform {
  transform(code: string): string {
    return LANGUAGE_DISPLAY_NAME_MAP.get(code) ?? code;
  }
}
